var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { forwardIconRef } from "../../lib/icons";
var AvatarIcon = forwardIconRef(function (_a, ref) {
    var _b = _a.color, color = _b === void 0 ? "#fff" : _b, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ ref: ref, xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20" }, props),
        React.createElement("path", { fill: "none", d: "M0 0h20v20H0z" }),
        React.createElement("path", { fill: color, d: "M17.2 18a.8.8 0 01-.795-.706l-.009-.235a2.4 2.4 0 00-2.255-2.259H6a2.4 2.4 0 00-2.4 2.4.8.8 0 01-1.6 0 4 4 0 013.827-4H14a4 4 0 014 4 .8.8 0 01-.8.8zM10 11.6a4.8 4.8 0 114.8-4.8 4.805 4.805 0 01-4.8 4.8zm0-8a3.2 3.2 0 103.2 3.2A3.2 3.2 0 0010 3.6z" })));
});
export default AvatarIcon;
